// Dependencies
import React from 'react';

import PropTypes from 'prop-types';

import { colors } from '@nerdwallet/base-styles/variables';
import C3Chart from '@nerdwallet/react-c3-chart';

// Configs
import colResultsTable from './col-results-table';
import demographicsResultsTable from './demographics-results-table';
import qolResultsTable from './qol-results-table';
import schoolResultsTable from './school-results-table';

const renderDemographicCharts = ({ cityData }) => {
  const ethnicityColumns = [
    ['Black', cityData.percent_black],
    ['Latino or Hispanic', cityData.percent_latino_or_hispanic],
    ['Asian', cityData.percent_asian],
    ['White', cityData.percent_white],
    ['Other', cityData.percent_other],
  ];

  const ageColumns = [
    ['Under 18', cityData.age_under_18],
    ['18 to 24', cityData.age_18_to_24],
    ['25 to 44', cityData.age_25_to_44],
    ['45 to 64', cityData.age_45_to_64],
    ['65+', cityData.age_65_plus],
  ];

  return (
    <div className="cl-results-demographics-pies">
      <div className="cl-results-demographics-pie">
        <h3 className="cl-results-demographics-pie-title">
          Ethnicity Breakdown
        </h3>
        <C3Chart
          data={{
            columns: ethnicityColumns,
            type: 'pie',
            colors: {
              Black: colors['blue-lighter'],
              'Latino or Hispanic': colors['red-lighter'],
              Asian: colors['yellow-lighter'],
              White: colors['green-lighter'],
              Other: colors['neutral-lighter'],
            },
          }}
        />
      </div>
      <div className="cl-results-demographics-pie">
        <h3 className="cl-results-demographics-pie-title">Age Breakdown</h3>
        <C3Chart
          data={{
            columns: ageColumns,
            type: 'pie',
            colors: {
              'Under 18': colors['blue-lighter'],
              '18 to 24': colors['red-lighter'],
              '25 to 44': colors['yellow-lighter'],
              '45 to 64': colors['green-lighter'],
              '65+': colors['neutral-lighter'],
            },
          }}
        />
      </div>
    </div>
  );
};

const renderHowItCompares = ({ cityData, onCompareClick, index }) => (
  <div key={cityData.cityState}>
    <a onClick={onCompareClick(index)}>
      <h3 className="cl-results-how-it-compares-link">
        See how {cityData.cityState} compares against America’s most popular
        cities?
      </h3>
    </a>
  </div>
);

export default [
  {
    id: 'col',
    title: 'Cost Of Living',
    config: colResultsTable,
  },
  {
    id: 'demographics',
    title: 'Demographics',
    config: demographicsResultsTable,
    children: renderDemographicCharts,
  },
  {
    id: 'qol',
    title: 'Quality of Life',
    config: qolResultsTable,
  },
  {
    id: 'school',
    title: 'School Information',
    config: schoolResultsTable,
  },
  {
    id: 'compare',
    title: 'How Does it Compare?',
    config: null,
    children: renderHowItCompares,
  },
];

renderHowItCompares.propTypes = {
  cityData: PropTypes.object.isRequired,
  onCompareClick: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

renderDemographicCharts.propTypes = {
  cityData: PropTypes.object.isRequired,
};
